import { useMutation, useQueryClient } from '@tanstack/react-query';

import { contentRegisterQueryKey } from 'components/hooks/contentRegisterQueries';

export function useDestroyCompanyTradeMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ companyTradeId }) => {
      const response = await axios.delete(`/company_trades/${companyTradeId}`);
      return response.data;
    },
    onSuccess: ({ meta }) => {
      if (meta.isContentRegisterAvailable) {
        queryClient.invalidateQueries({ queryKey: contentRegisterQueryKey });
      }
    },
  });
}

// Optimistic order lives in the caller's local state, not the query cache: dnd-kit only animates a drop if the new order renders synchronously in onDragEnd.
export function useSortCompanyTradesMutation() {
  return useMutation({
    mutationFn: async ({ companyTradeIds }) => {
      await axios.patch('/company_trades/sort', {
        company_trade: companyTradeIds,
      });
    },
  });
}
